const VARIANT_CLASS = {
  default: '',
  accent: 'ledger-tag--accent',
  warn: 'ledger-tag--warn',
  danger: 'ledger-tag--danger',
  muted: 'ledger-tag--muted',
}

/** 线框标签，替代 Ant 彩色实心 Tag */
export default function LedgerTag({ children, variant = 'default', style }) {
  const cls = ['ledger-tag', VARIANT_CLASS[variant] || ''].filter(Boolean).join(' ')
  return (
    <span className={cls} style={style}>
      {children}
    </span>
  )
}
